import React, { FunctionComponent } from 'react'
import Grid from '@sport1/react-elements/Grid'
import SmallBodyFont from '../../../../Theme/Fonts/SmallBody'

type SetResultType = 'CURRENT' | 'OVERALL' | 'OVERALL_LIVE' | 'DEFAULT'

type SetResultProps = {
    type: SetResultType
    homeScore: number
    awayScore: number
}

const getStylingProps = (
    type: SetResultType
): {
    backgroundColor?: 'onyx-5'
    bold?: boolean
    color: 'onyx' | 'keshi-3' | 'pearl'
    spaceBetween: '8px' | '9px'
} => {
    switch (type) {
        case 'OVERALL_LIVE':
            return {
                backgroundColor: 'onyx-5',
                color: 'pearl',
                bold: true,
                spaceBetween: '8px',
            }
        case 'OVERALL':
            return {
                color: 'onyx',
                bold: true,
                spaceBetween: '9px',
            }
        case 'CURRENT':
            return {
                color: 'onyx',
                spaceBetween: '9px',
            }
        default:
            return {
                color: 'keshi-3',
                spaceBetween: '9px',
            }
    }
}

const SetResult: FunctionComponent<SetResultProps> = ({ type, homeScore, awayScore }) => {
    const { color, bold, backgroundColor, spaceBetween } = getStylingProps(type)
    return (
        <Grid
            backgroundColor={backgroundColor}
            noExpand
            centerHorizontal
            width={20}
            borderRadius="2px"
        >
            <SmallBodyFont numberOfLines={1} color={color} bold={bold} paddingBottom={spaceBetween}>
                {`${homeScore}`}
            </SmallBodyFont>
            <SmallBodyFont numberOfLines={1} color={color} bold={bold}>
                {`${awayScore}`}
            </SmallBodyFont>
        </Grid>
    )
}
export default SetResult
